import * as React from 'react';
import { AccordionWrapperProps, AccordionWrapperState } from '../../../types';
import MultiTradeInRouting from '../MultiTradeInRouting';
import AccordionIcon from '../icons/AccordionIcons';
import { PendingAppraisal } from '../../../utils';

class AccordionWrapper extends React.Component<AccordionWrapperProps, AccordionWrapperState> {
    constructor(props: AccordionWrapperProps) {
        super(props);
    }

    toggleExpanded = (): void => {
        this.props.toggleAccordionState(this.props.tradeIndex);
    };

    render() {
        const { title, tradeIndex } = this.props;
        const { value, amountOwed, currentUserLocationRoute, vehicle } = this.props.tradeIn.tradeInComponent;
        const { make, model, year, trim } = vehicle;
        const { isExpanded } = this.props.tradeIn;
        const tradeEquity = Number(value) - Number(amountOwed) || 0;

        return (
            <div className="accordion-wrapper" data-testid="multi-tradein-accordion">
                <div className="accordion-header">
                    <div className="accordion-header-content">
                        <h3 className="accordion-title" data-testid="accordion-title">
                            {title} {tradeIndex + 1}
                            {year ? `: ${year} ${make?.name || ''} ${model?.name || ''} ${trim?.name || ''}` : ''}
                        </h3>
                        {!isExpanded && (
                            <div className="accordion-summary">
                                <div className="accordion-summary-item" data-testid="accordion-summary-tradein-value">
                                    <span className="accordion-label">Trade In Value</span>
                                    <span className="accordion-value">
                                        {value === 0 ? PendingAppraisal : `$${value.toLocaleString('en-US')}`}
                                    </span>
                                </div>
                                <div
                                    className="accordion-summary-item accordion-summary-item-payoff"
                                    data-testid="accordion-summary-payoff"
                                >
                                    <span className="accordion-label">Payoff</span>
                                    <span className="accordion-value">- ${amountOwed.toLocaleString('en-US') || 0}</span>
                                </div>
                                <div
                                    className="accordion-summary-item accordion-summary-item-equity"
                                    data-testid="accordion-summary-equity"
                                >
                                    <span className="accordion-label">Trade Equity</span>
                                    <span className="accordion-value">
                                        {value === 0 ? PendingAppraisal : `$${tradeEquity.toLocaleString('en-US')}`}
                                    </span>
                                </div>
                            </div>
                        )}
                    </div>
                    <span
                        className="accordion-toggle"
                        onClick={this.toggleExpanded}
                        aria-label={isExpanded ? 'Collapse' : 'Expand'}
                        aria-expanded={isExpanded}
                        data-testid="accordion-toggle"
                    >
                        <AccordionIcon isExpanded={isExpanded} />
                    </span>
                </div>

                {isExpanded && (
                    <div className="accordion-content" data-testid="accordion-content">
                        <MultiTradeInRouting tradeInRoute={currentUserLocationRoute} {...this.props} />
                    </div>
                )}
            </div>
        );
    }
}

export default AccordionWrapper;
